import { HiOutlineMenu, HiOutlineBell } from 'react-icons/hi';
import ThemeToggle from '@/components/common/ThemeToggle';

interface MobileHeaderProps {
  onMenuClick: () => void;
}

function MobileHeader({ onMenuClick }: MobileHeaderProps): JSX.Element {
  return (
    <header className="mobile-header">
      <button 
        className="mobile-menu-btn"
        onClick={onMenuClick}
        aria-label="Abrir menú"
      >
        <HiOutlineMenu />
      </button>

      <div className="sidebar-logo">
        <div 
          className="sidebar-logo-icon" 
          style={{ width: 36, height: 36, fontSize: '1.125rem' }}
        >
          <span style={{ fontWeight: 700 }}>A</span>
        </div>
      </div>

      <div className="d-flex align-items-center gap-2">
        <ThemeToggle compact />
        <button className="mobile-menu-btn" aria-label="Notificaciones">
          <HiOutlineBell />
        </button>
      </div>
    </header>
  );
}

export default MobileHeader;
